import { render, staticRenderFns } from "./fundMarket.vue?vue&type=template&id=28b9227b"
import script from "./fundMarket.vue?vue&type=script&lang=js"
export * from "./fundMarket.vue?vue&type=script&lang=js"
import style0 from "./fundMarket.vue?vue&type=style&index=0&id=28b9227b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports